import { ViewState } from "redux/constants/App";

export const setIdle = ({ state, statusKeys }) => ({
    ...state,
    ...statusKeys.reduce((acc, statusKey) => ({ ...acc, [statusKey]: ViewState.IDLE }), {})
});

export const setBusy = ({ state, statusKey }) => ({
    ...state,
    [statusKey]: ViewState.BUSY
});

export const setError = ({ state, statusKey, error }) => ({
    ...state, [statusKey]: ViewState.ERROR, error
});

export const setReady = ({ state, statusKey, payload }) => ({
    ...state,
    [statusKey]: ViewState.READY,
    ...payload
});
